function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 8c0-.551-.449-1-1-1s-1 .449-1 1v3h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 17h14.618l1.935 3.87c.097.195.447.113.447-.106v-16.764c0-.551-.449-1-1-1h-16c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1zm5-9c0-1.654 1.346-3 3-3s3 1.346 3 3v7h-2v-2h-2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m47 12c0-.551-.449-1-1-1h-1v2h1c.551 0 1-.449 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m47 8c0-.551-.449-1-1-1h-1v2h1c.551 0 1-.449 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.448 20.869 1.934-3.869h14.618c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1h-16c-.551 0-1 .449-1 1v16.764c0 .219.35.301.448.105zm5.552-15.869h3c1.654 0 3 1.346 3 3 0 .768-.29 1.469-.766 2 .476.531.766 1.232.766 2 0 1.654-1.346 3-3 3h-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 29c-.551 0-1 .449-1 1v3h2v-3c0-.551-.449-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.085 29h-.171c-1.055 0-1.914.859-1.914 1.915v2.171c0 1.055.859 1.914 1.915 1.914h.171c1.055 0 1.914-.859 1.914-1.915v-2.171c0-1.055-.859-1.914-1.915-1.914z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60 25h-16c-.551 0-1 .449-1 1v16.764c0 .219.35.301.448.105l1.934-3.869h14.618c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1zm-4 8.085c0 2.159-1.756 3.915-3.915 3.915h-.171c-2.158 0-3.914-1.756-3.914-3.915v-2.171c0-2.158 1.756-3.914 3.915-3.914h.171c2.158 0 3.914 1.756 3.914 3.915z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.236 45c-1.233 0-2.236-1.003-2.236-2.236v-5.26l-8.352-14.134c-.27-.456-1.026-.456-1.296 0l-8.352 14.134v5.26c0 1.233-1.003 2.236-2.236 2.236-.494 0-.949-.174-1.327-.456-.279 1.068-.437 2.164-.437 3.283v.173c0 7.168 5.832 13 13 13s13-5.832 13-13v-.173c0-1.119-.158-2.215-.437-3.284-.379.283-.833.457-1.327.457zm-5.236 5h-4v4h-4v-4h-4v-4h4v-4h4v4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 42.764v-16.764c0-.551-.449-1-1-1h-16c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h14.618l1.935 3.87c.097.195.447.113.447-.106zm-10-5.764h-2v-2h-2v2h-2v-7c0-1.654 1.346-3 3-3s3 1.346 3 3zm8-3c0 1.654-1.346 3-3 3h-3v-10h3c1.654 0 3 1.346 3 3 0 .768-.29 1.469-.766 2 .476.531.766 1.232.766 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 29h-1v2h1c.551 0 1-.449 1-1s-.449-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 33h-1v2h1c.551 0 1-.449 1-1s-.449-1-1-1z"
}));

const SvgBloodType = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBloodType, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BloodType.8c0aadfd.svg";
export { ForwardRef as ReactComponent };